import { Controller } from "react-hook-form";
import { TextField } from "@material-ui/core";
import { useInputStyles } from "../inputs.styles";
import { DatePickerProps } from "./date-picker.props";

export const Datepicker = (props: DatePickerProps) => {
  const classes = useInputStyles();

  return (
    <Controller
      control={props.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <label className={classes.wrapper}>
          <span className={classes.label}>{props.label}</span>
          <TextField
            {...renderProps.field}
            error={props.error}
            size="small"
            type="date"
            variant="outlined"
            placeholder="yyyy-mm-dd"
          />
        </label>
      )}
    />
  );
};
